import { h, render } from 'preact';

import { PaymentButtonEntry, PaymentButtonsView } from '../types/payment-buttons';
import { PaymentButtonsArranger } from './components/PaymentButtonsArranger';
import { getPaymentButtonsArrangerProps } from './props/app/PaymentButtonsArranger';

/**
 * The Payment buttons page, where the cinema arranges the checkout's buttons by dragging them. The page holds the
 * arrangement and saves it: a `payment-buttons-arranged` event tells it of a new one, and it sends back the one it
 * holds after saving with a `payment-buttons-entries` event.
 */
export const initPaymentButtons = (): void => {
    const container = document.querySelector<HTMLElement>('.js-payment-buttons');

    if (!container) {
        return;
    }

    const view: PaymentButtonsView = {
        state: { ...window.initialPaymentButtonsState, dragged: null, dragOver: null, notice: '' },
        update: (): void => {
            render(h(PaymentButtonsArranger, getPaymentButtonsArrangerProps(view)), container);
        },
        arranged: (entries: PaymentButtonEntry[]): void => {
            container.dispatchEvent(new CustomEvent('payment-buttons-arranged', { detail: entries, bubbles: true }));
        },
    };

    container.addEventListener('payment-buttons-entries', (event: Event): void => {
        view.state.entries = (event as CustomEvent<PaymentButtonEntry[]>).detail;
        view.update();
    });

    view.update();
};
